import List from 'containers/SalarySteps/List';
import Edit from 'containers/SalarySteps/Edit';
import Create from 'containers/SalarySteps/Create';
import Show from 'containers/SalarySteps/Show';

export default { List, Edit, Create, Show };
